import { useBackendQuery } from '../useBackendQuery'

export interface UseStoreQueryProps {
  /** The slug of the store to fetch products for. */
  store: string | null
}

export function useStoreQuery<Store>(options: UseStoreQueryProps) {
  const { store } = options

  const query = useBackendQuery<Store>(store && [`stores/${store}`])

  return query
}

export default useStoreQuery
